export default "__VITE_ASSET__4a94a00e__"